import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import { useParams } from 'react-router-dom';
import './styles/TransferInventoryPage.css';
import { useNavigate } from 'react-router-dom'; 

const CostFormPage = () => {
    const { costId } = useParams(); 
    const [cost, setCost] = useState(null); // Ubah ke null untuk memudahkan pengecekan
    const [price, setPrice] = useState('');
    const [itemName, setItemName] = useState('');
    const [itemType, setItemType] = useState('');
    const [program, setProgram] = useState('');
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        api.post('/utils/cost/getCostFromId', { data: { costId: costId }})
          .then(response => {
            const costData = response.data.data.cost; // Akses data dengan benar
            setCost(costData);
            setItemName(costData.cost_item); // Setel item_name
            setItemType(costData.item_type); // Setel item_type
            setPrice(costData.cost_amount); // Setel cost_amount
            setProgram(costData.Program ? costData.Program.program_name : '-'); // Setel program_name
        })
          .catch(error => console.error('Error fetching cost data:', error));
        
    }, [costId]);
    
    const formatCurrency = (amount) => {
        return parseFloat(amount).toLocaleString('id-ID', { minimumFractionDigits: 0 });
    };
    
    const handlePriceChange = (e) => {
        const value = e.target.value.replace(/\./g, '');
        if (value === '') {
            setPrice(0);
        } else {
            e.target.value = formatCurrency(value); 
            setPrice(value); // Simpan nilai asli tanpa format
        }
    };

    const validateForm = () => {
        const errors = {};
        if (price === 0) errors.price = 'Price is required';
        return errors;
    };
   
    const handleSubmit = () => {
        const validationErrors = validateForm();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            console.log('Validation Errors:', validationErrors);
        } else {
            const confirmation = window.confirm('Are you sure you want to proceed with this action?');
            if (!confirmation) {
                return;
            }
            
            const costData = {
                data: {
                    costData: {
                        cost_id: cost.cost_id,
                        cost_amount: price
                    },
                },
            };

            console.log(costData);
        
            api.post(`utils/cost/update`, costData)
            .then(response => {
                const successMessage = response.data.message;
                console.log(successMessage);
                navigate('/success', { state: { message: successMessage } });
            })
            .catch(error => {
                console.error('Error updating price:', error);
                navigate('/error', { state: { message: 'Please ask to administrator!' } });
            });
        }
    };

    return (
        <div className="transfer-inventory-page">
            <div className="page-title">Price Edit</div>
            <div className="form-container">
                <div className="section">
                    <h3 className="section-header">Item Data</h3>
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Item Name</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="text"
                                            value={itemName} 
                                            readOnly
                                        />
                                    </td>  
                                </tr>
                                <tr>
                                    <td>
                                        <label>Item Type</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="text"
                                            value={itemType} 
                                            readOnly
                                        />
                                    </td> 
                                </tr>
                                <tr>
                                    <td>
                                        <label>Item Price</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="text" // Ubah ke text untuk format mata uang
                                            value={formatCurrency(price)}      
                                            onChange={handlePriceChange} 
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    {errors.price && 
                                    <td>
                                        <div className="error-message">{errors.price}</div>
                                    </td>
                                    }
                                </tr>
                                <tr>
                                    <td>
                                        <label>Program Name</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input
                                                type="text" 
                                                value={program} 
                                                readOnly
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="search-container">
                    <button className="profile-button" onClick={handleSubmit}>Submit</button>
                </div>
            </div>
        </div>
    );
};

export default CostFormPage;
